import { IOpData } from "../util/interfaces"

import { OpDataType } from "."
import { OpChangeState } from "../common/enums"

export class OpOperatorGroupData implements IOpData {

    // #region Properties

    public idOperatorGroupData: number
    public idOperatorGroup: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // #endregion

    // #region Navigation Properties

    public dataType: OpDataType

    // #endregion

    // #region Custom Properties

    public opState: OpChangeState
    public referencedObject: any
    public previousValue: any

    // #endregion


    // #region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion


    // #region IOpData Implementation

    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }
    public get idData() { return this.idOperatorGroupData }
    public set idData(idData: number) { this.idOperatorGroupData = idData }

    // #endregion


    // #region Public Methods

    public toJSON(compressed: boolean) {
        return {
            ID_OPERATOR_GROUP_DATA: this.idOperatorGroupData,
            ID_OPERATOR_GROUP: this.idOperatorGroup,
            INDEX_NBR: this.indexNbr,
            ID_DATA_TYPE: this.idDataType,
            VALUE: this.value,
            ID_DATA: this.idData,
            OpState: this.opState
        }
    }

    public fromJSON(opObj: any) {
        if (opObj) {
            this.idOperatorGroupData = opObj.ID_OPERATOR_GROUP_DATA
            this.idOperatorGroup = opObj.ID_OPERATOR_GROUP
            this.indexNbr = opObj.INDEX_NBR
            this.idDataType = opObj.ID_DATA_TYPE
            this.value = opObj.VALUE
            this.idData = opObj.ID_DATA
            this.opState = opObj.OpState
        }
    }

    public static fromIOpData(data: IOpData): OpOperatorGroupData {
        const newData: OpOperatorGroupData = new OpOperatorGroupData(null)

        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    public toString() {
        return this.idOperatorGroupData.toString()
    }

    // #endregion 

}